
export default function initWrapperLink() {
    const $blocksWrapperLink = document.querySelectorAll<HTMLElement>('.js-wrapper-link');
    $blocksWrapperLink.forEach($container => {
        new WrapperLink($container);
    });
}

/**
 * @param {HTMLElement} $el           HTML Element Block nos offres
 */
class WrapperLink {
    $el: HTMLElement | null | undefined;
    $link: HTMLElement | null | undefined;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$link = $el?.querySelector('a');

        this.init();
    }

    init() : void {
        if (this.$link) {
            this.$el?.addEventListener('click', (e) => {
                e.preventDefault();
                window.location.href = this.$link?.href;
            });
        }
    }
}
